export default __webpack_public_path__ + "static/media/add_common_service.73648171.png";